module.exports = __webpack_public_path__ + "static/media/redensyfing.a2647477.svg";